@import '~style-sheet-helpers/core.less';
@import '../../../../../../../src/constants/spacing.module.less';
@import '../../../../../../../src/constants/screen-width-breakpoints.module.less';

.discounted-rates-step {
  display: flex;
  flex-direction: column;
  gap: @space-24;
  text-align: left;
  margin: @space-0 10% @space-16 10%;

  @media @mobile, @ultramobile {
    margin: @space-0 @space-0 @space-16;
  }
}

.discount-rates-step-header {
  align-items: flex-start;
}

.link {
  margin-top: @space-8;
}

.link-icon {
  margin-left: @space-8;
  width: @space-12;
  height: @space-12;
}

.header {
  font-weight: 700;
}

.section {
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  border-radius: 8px;
  padding: @space-16;
  border: 1px solid var(--gray-E4E5E7);
}

.rate-shopper-selection-list {
  display: flex;
  flex-direction: column;
  gap: @space-16;
  margin-top: 16px;
}

.rate-shopper-option {
  border: 1px solid var(--gray-E4E5E7);
  border-radius: 8px;
  padding: @space-8 @space-16;
}

.rate-shopper-option-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.rate-shopper-option.selected {
  border: 2px solid var(--blue-1D5AD8);
  background-color: var(--blue-EDF6FF);
}

.rate-shopper-option-content {
  display: flex;
  flex-direction: column;
  gap: @space-4;
  margin-left: @space-16;
}

.rate-shopper-option-title {
  font-weight: 600;
}

.rate-shopper-option-description {
  color: var(--gray-637381);
  font-size: 14px;
}

.default-badge {
  background-color: var(--gray-818F9C);
  border-radius: 4px;
  padding: @space-8;
  font-size: 12px;
  color: var(--white);
}

.automation-activation {
  display: flex;
  flex-direction: column;
  gap: @space-16;
  margin-top: 16px;
}

.automation-suggestion-activation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--gray-E4E5E7);
  border-radius: 8px;
  padding: @space-16;
  margin-bottom: @space-8;
}

.automation-suggestion-content {
  display: flex;
  flex-direction: column;
  gap: @space-4;
}

.automation-suggestion-description {
  color: var(--gray-637381);
  font-size: 14px;
}

.activate-button {
  min-width: 100px;
}

.rate-shopper-checkbox {
  padding: @space-0;
}

.edit-button-content {
  display: flex;
  align-items: center;
  gap: @space-8;
  justify-self: center;

  > svg {
    width: 16px;
    height: 16px;
  }
}

.create-rule-link {
  margin-bottom: @space-16;
  align-self: flex-start;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.skip-warning {
  text-align: left;
  margin-top: @space-8;
  border-radius: 8px;
}

.active-parcel-guard-rules-banner {
  text-align: left;
  margin-top: @space-8;
  border-radius: @space-8;
}

.active-parcel-guard-rules-banner a {
  color: var(--blue-600);
  text-decoration: none;
}

.active-parcel-guard-rules-banner a:hover {
  text-decoration: underline;
}

.loading {
  width: 48px;
  height: 48px;
  margin: 0 auto;
}

.info-icon {
  display: flex;
  align-items: center;
  width: 14px;
  margin-left: @space-8;
  color: var(--gray-818F9C);
}
